import enquire from "enquire.js"
import { useEffect, useState } from "react"

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const handler = {
      match: () => setMatches(true),
      unmatch: () => setMatches(false),
    }

    enquire.register(query, handler)

    return () => {
      enquire.unregister(query, handler)
    }
  }, [query])

  return matches
}
